/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mk_Loop_1_CmdInputs */

const en_mk_loop_1_cmd = /** @type {(inputs: Mk_Loop_1_CmdInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`bystep task next`)
};

const id_mk_loop_1_cmd = /** @type {(inputs: Mk_Loop_1_CmdInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`bystep task next`)
};

/**
* | output |
* | --- |
* | "bystep task next" |
*
* @param {Mk_Loop_1_CmdInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const mk_loop_1_cmd = /** @type {((inputs?: Mk_Loop_1_CmdInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mk_Loop_1_CmdInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_mk_loop_1_cmd(inputs)
	return en_mk_loop_1_cmd(inputs)
});